export default __webpack_public_path__ + "alberta-fab-order.562993d5d13f05d2930c.svg";